import { render, staticRenderFns } from "./CoherenceAnalysisTab.vue?vue&type=template&id=53530cba&scoped=true"
import script from "./CoherenceAnalysisTab.vue?vue&type=script&lang=js"
export * from "./CoherenceAnalysisTab.vue?vue&type=script&lang=js"
import style0 from "./CoherenceAnalysisTab.vue?vue&type=style&index=0&id=53530cba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53530cba",
  null
  
)

export default component.exports